import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Tabs, Input } from 'antd'
import { type FC, useState } from 'react'
import { Link } from 'react-router-dom'
import { PageHeader } from '~/components/PageHeader'
import ActiveUserList from './ActiveUserList'
import DisabledUserList from './DisabledUserList'

const Users: FC = () => {
  const [filterInput, setFilterInput] = useState('')

  return (
    <>
      <PageHeader
        className="radup-page-header"
        title="Users"
        extra={[
          <Input.Search
            key={1}
            placeholder="Search"
            allowClear
            enterButton={<SearchOutlined />}
            onSearch={setFilterInput}
          />,
          <Link key={2} to={'create'}>
            <Button type="primary">
              <PlusOutlined /> New User
            </Button>
          </Link>
        ]}
      />
      <Tabs defaultActiveKey='users' items={[
        {
          key: 'users',
          label: 'Active Users',
          children: <ActiveUserList filterInput={filterInput} />
        },
        {
          key: 'disabled-users',
          label: 'Past Users',
          children: <DisabledUserList filterInput={filterInput} />
        }
      ]} />
    </>
  )
}

export default Users
